export const timeScaleRangeTypes = {
  daily: 'daily',
  payPeriod: 'payPeriod',
  fourWeeks: 'fourWeeks',
  oneMonth: 'oneMonth',
  threeMonths: 'threeMonths',
  sixMonths: 'sixMonths',
  custom: 'custom',
};
